var React = require('react');

function Mic (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z","key":0}),React.createElement("path",{"d":"M19 10v2a7 7 0 0 1-14 0v-2m7 9v3","key":1})]);
}

Mic.defaultProps = {"width":"24","height":"24","fill":"none","stroke":"#F0626D","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Mic;

Mic.default = Mic;
